<template>

  <div  style="background-color: white" >
    <header class="bar bar-nav" v-if="!isWapp">
      <button class="button button-link button-nav pull-left" >
        <span class="icon icon-left goback" @click="gotolast()" style="font-size: .8rem">返回</span>
        <span class="goback" style="margin-left: 4rem" >
           订单详情
        </span>
      </button>

      <div class="buttons-row" style="margin-top: 2.5rem;;font-size: .6rem;">
       重要提示：为了确保您的科研需求，请认真核对您的定制产品参数，我们将严格按照您的要求进行产品生产。如因您产品参数原因导致您后续的实验问题，我司无法针对此种情况为您进行免费售后服务。

      </div>
    </header>
    <header v-if="isWapp">
      <div class=" bar_1 buttons-row" style="margin-top: 8px;;font-size: .6rem;">
       重要提示：为了确保您的科研需求，请认真核对您的定制产品参数，我们将严格按照您的要求进行产品生产。如因您产品参数原因导致您后续的实验问题，我司无法针对此种情况为您进行免费售后服务。
      </div>
    </header>
    <div  class="content"   style="margin-bottom: 1rem;background-color: white;overflow-y: auto;overflow-x: hidden;margin-top: 4rem">

      <div class="page-detail"  style="background-color: white" >
        <div class="item-subtitle" style="color: #0894ec;margin-left: 1rem"  >
          <div v-if="merchandises.specialAnnouncement!== undefined" style="margin-left: 1rem;font-size: .6rem;color: red" >
            注：{{merchandises.specialAnnouncement}}
          </div>
          <div class="item-title-row"  v-if="filteredShowPromotions && filteredShowPromotions.length > 0" >
            <div style="color: slateblue;font-size: 0.6rem;margin-left: 0.2rem">参与促销：
              <div v-for="(proo,index) in filteredShowPromotions">
                <span>{{index+1}}: {{proo.description}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="content-block" :style="{'margin-top': '.55rem', 'margin-bottom': emkt.leaveSpaceForFullScreen ? '85px' : '35px'}">
          <div class="list-block">
            <ul>
              <li v-for="(attribute,index) in merchandises._attributesList" class="item-content" v-if="attribute.displayable !== 0 && attribute.value !== '214' && attribute.value !== 214  && attribute.value !== '-1'  && attribute.value !== -1 &&  attribute.groupId === 1">
                <editor :is="getEditor(attribute)" v-on:controlForm="controlForm" :attribute="attribute"  :merchandises='merchandises':attrGroups = "attrGroups" :index="index"  :attributesList="merchandises._attributesList" />
              </li>
              <hr style="margin-left: 0.7rem;margin-right: 0.1rem; border: 0.5px solid #e7e7e7;">
              <li v-for="(attribute,index) in merchandises._attributesList" class="item-content" v-if="attribute.displayable !== 0  && attribute.value !== 'null' && attribute.value !== '214' && attribute.value !== 214 && attribute.value !== '-1'  && attribute.value !== -1 &&  attribute.groupId === 2">
                <editor :is="getEditor(attribute)" v-on:controlForm="controlForm" :attribute="attribute"  :merchandises='merchandises':attrGroups = "attrGroups" :index="index"  :attributesList="merchandises._attributesList" />
              </li>
              <li class="item-content">
                <div class="item-inner" >
                  <div class="item-title" style="color: gray;font-size: .7rem">产品规格</div>
                  <div class="item-after" style="background-color: #E1E1E4;">
                  </div>
                </div>
              </li>
              <li v-for="(attribute,index) in merchandises._attributesList" class="item-content" v-if="attribute.displayable !== 0 && attribute.value !== '214' && attribute.value !== 214 && attribute.value !== '-1' && attribute.value !== -1 &&  attribute.groupId === 3">
                <editor :is="getEditor(attribute)" v-on:controlForm="controlForm" :attribute="attribute"  :merchandises='merchandises':attrGroups = "attrGroups" :index="index"  :attributesList="merchandises._attributesList" :type="1" />
              </li>
              <li class="item-content">
                <div class="item-inner ">
                  <div class="item-title">周期</div>
                  <div class="item-after" v-if="merchandises.workdays">{{merchandises.workdays}}个工作日</div>
                  <div class="item-after" v-else>{{merchandises.cycle}}个工作日</div>
                </div>
              </li>
              <li class="item-content">
                <div class="item-inner ">
                  <div class="item-title">价格</div>
                  <div class="item-after" v-if="merchandises.priceMax">¥{{emkt.formatPrice(merchandises.priceMax)}}</div>
                  <div class="item-after" v-else >¥{{emkt.formatPrice(merchandises.price)}}</div>
                </div>
              </li>

              <li class="item-content" v-if="merchandises.priceMin">
                <div class="item-inner ">
                  <div class="item-title">科研终端用户优惠价</div>
                  <div class="item-after" >¥{{emkt.formatPrice(merchandises.priceMin)}}</div>
                </div>
              </li>
              <!--定制商品显示秒杀折扣-->
              <li class="item-content" v-if="showSecPromotionInfo()">
                <div class="item-inner" v-if="merchandises.categoryId === 20">
                  <div class="item-title" style="color:#ff0000;">{{numRequiredForSecPromotion}}件秒杀折扣</div>
                  <div class="item-after" style="color:#ff0000;">{{secPromotionRatio}}折</div>
                </div>
                <div class="item-inner" v-else>
                  <div class="item-title" style="color:#ff0000;">{{numRequiredForSecPromotion}}件秒杀价</div>
                  <div class="item-after" style="color:#ff0000;">
                    <span v-if="secPromotionDetail && secPromotionDetail.seckillType === 1">¥{{((1 - secPromotionDetail.seckilltRatio) * merchandises.priceMin).toFixed(2)}}</span>
                  </div>
                </div>

              </li>
            </ul>
            <div style="font-size: .4rem;margin-left: .5rem;color: gray">


              不同产品分装规则说明
              <div >
                1.菌液:200μL/tube*1
              </div>
              <div>
                2.质粒:不分装
              </div>
              <div>
                3.慢病毒:50μL/tube
              </div>
              <div>
                4.腺病毒:200μL/tube
              </div><div>
              5.逆转录病毒:50μL/tube
            </div>
              <div>
                6.腺相关病毒:50μL/tube
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="bar  bar-tab" :style="{'border-top': '0px solid #e7e7e7', 'height': emkt.leaveSpaceForFullScreen ? '85px' : '50px'}"  v-if="this.$route.query.id === undefined">
      <!--<div class="item-media">-->
        <!--<section class="gotopay" >-->
          <!--<span class="gotopay_button_style" style="padding-top: 0rem;">加入购物车</span>-->
        <!--</section>-->
      <!--</div>-->
      <!--<div style="float: left">-->
        <!--返回修改-->
      <!--</div>-->
      <div class="tab-item" style="background-color: #00469A;color: white;width: 80px" @click="gotofindermerchdisesdetail()">
          <span class="tab-label">返回修改</span>
      </div>
      <div class="tab-item" style="width: 10rem" @click="gotoCart">
          <span class="icon icon-cart" ></span>
          <span class="tab-label">购物车</span>
          <span class="badge" v-if = "getTotalGoodsNum > 0">{{getTotalGoodsNum}}</span>
      </div>
      <span v-if="!isWapp">
        <section class="gotopay" v-if="QuoteStatus === false" v-on:click="calculatePrice">
        <span class="gotopay_button_style" style="padding-top: 0rem;margin-bottom: .4rem" >确认</span>
      </section>
      <section class="gotopay" v-else  style="background-color: gray">
      </section>
      </span>
      <span v-else>
        <section class="gotopay" v-if="QuoteStatus === false" v-on:click="calculatePrice">
        <span class="gotopay_button_style" style="padding-top: 0rem;margin-bottom: .4rem" >确认</span>
      </section>
      <section class="gotopay" v-else  style="background-color: gray">
      </section>
      </span>
    </footer>
  </div>

</template>

<script>
  import {mapState, mapMutations, mapGetters} from 'vuex'
  import FinderAttrEnumBox from '../FinderBox/FinderAttrEnumBox.vue'
  import FinderAttrNumberBox from '../FinderBox/FinderAttrNumberBox.vue'
  import FinderAttrTextAreaBox from '../FinderBox/FinderAttrTextAreaBox.vue'
  import FinderAttrTextBox from '../FinderBox/FinderAttrTextBox.vue'
  import FinderAttrGeneBox from '../FinderBox/FinderAttrGeneBox.vue'
  import FinderAttrTVBox from '../FinderBox/FinderAttrTVBox.vue'
  import Emkt from '../../../emkt'
  import  MerchandisesMixin from '../../../views_v_2.6/PrivateMixins/MerchandisesMixin'
  // import $ from 'jquery'
  import wx from 'wx'
  export default {
    // 在 props 中声明获取父组件的数据通过 message 传过来
    props: [],
    components: {
      'finder-attr-enum-box': FinderAttrEnumBox,
      'finder-attr-text-box': FinderAttrTextBox,
      'finder-attr-number-box': FinderAttrNumberBox,
      'finder-attr-text-area-box': FinderAttrTextAreaBox,
      'finder-attr-gene-box': FinderAttrGeneBox,
      'finder-attr-tv-box': FinderAttrTVBox
    },
    data () {
      return {
        attrGroups: [],
        curAttrsInGroup: [],
        promotions: [],
        merchandises: [],
        baseurl: '/emktResources/resocurces/img/merchandise/',
        manualurl: '/emktResources/resocurces/manual/',
        Comments: [],
        QuoteStatus: Emkt.getLocalStorage('QuoteStatus'),
        qualityCommitment: '',
        introduces: '',
        geneObject: {},
        seckilltRatio: 0,
        numRequiredForSecPromotion: 0,
        secPromotionDetail: {},
        isWapp: Emkt.isWapp
      }
    },
    created () {
      // 组件创建完后获取数据，
      // 此时 data 已经被 observed 了
      this.fetchData()
    },
    mixins: [MerchandisesMixin],
    computed: {
      ...mapState([
        'cartList', 'sessionInfo', 'secPromotionDetailObj', 'customerOpenId'
      ]),
      ...mapGetters([
        'secFlag', 'hasLogin'
        // ...
      ]),
      filteredShowPromotions () {
        if (this.merchandises.showpromotion && this.merchandises.showpromotion.length > 0) {
          return this.merchandises.showpromotion.filter(pro => pro.requiredCustomers === 0 && pro.description && (pro.type === 1 || pro.type === 6))
        }
        if (this.merchandises.bpromotions && this.merchandises.bpromotions.length > 0) {
          return this.merchandises.bpromotions.filter(pro => pro.requiredCustomers === 0 && pro.description && (pro.type === 1 || pro.type === 6))
        }
        return []
      },
//      title () {
//        if (this.merchandiseAttributes === []) {
//          return ''
//        } else {
//          return this.merchandiseAttributes[0].valueText
//        }
//      },
//      merchandiseAttributes () {
//        if (this.merchandise._attributesList === []) {
//          return []
//        } else {
//          return this.merchandise._attributesList
//        }
//      },
      getTotalGoodsNum () {
        var self = this
        let sum = 0
        Object.keys(this.cartList.cartContent).forEach(function (item) {
          sum += self.cartList.cartContent[item].productQuantity
        })
        return sum
      },
      secPromotionRatio () {
        let ratio = String(100 - this.secPromotionDetail.seckilltRatio * 100)
        ratio = (ratio[1] === '0') ? ratio[0] : ratio
        return ratio
      }
//      merchandiseList: function () {
//        this.gcapi('getMerchandiseDetails', this.$route.query.id).then((response) => {
//          this.merchandises = response.body.result
//          this.merchandises.tags = this.$route.query.tags
//          this.merchandises.attrs = this.$route.query.attrs
//          this.merchandises.attributesList = response.body.result._attributesList
//        })
//        return this.merchandises
//      }
    },
    methods: {
      ...mapMutations([
        'ADD_CART_LIST', 'SHOW_GOODS', 'SEND_MESSAGE'
      ]),
      addCartList (bMerchandise) {
        console.log(this.merchandises.expressPrice)
        if (this.merchandises.priceMin) {
          bMerchandise.priceMin = this.merchandises.priceMin
          bMerchandise.priceMax = this.merchandises.priceMax
        } else {
          bMerchandise.priceMin = this.merchandises.price
          bMerchandise.priceMax = this.merchandises.price
        }
        bMerchandise.attributes['GeneInfo'] = this.geneObject
        let id = bMerchandise.merchandiseId
        id = id + new Date().getTime()
        bMerchandise.cartid = id
        if (bMerchandise.promotions) {
          bMerchandise.promotions.sort(function (a, b) {
            return a.priority - b.priority
          })
        }
        bMerchandise.newMerch = 1
        this.ADD_CART_LIST(bMerchandise)
        this.checkFromWeapp()
      },
      checkFromWeapp () {
        // 小程序添加商品，游客状态需先登录，登录状态需手动保存购物车，且不自动跳转到购物车
        if (Emkt.isWapp) {
          // 游客保存在本地
          if (this.cartList.saveToDBOrLocalStorage === false) {
            console.log('游客登录状态 需要先登录')
            wx.miniProgram.switchTab({
              url: '/pages/login/login'
            })
            this.$weui.loading().hide()
            return
          } else {
            this.saveCartManually()
          }
        } else {
          this.$weui.loading().hide()
          this.$router.push({name: 'cart'})
        }
      },
      gotofindermerchdisesdetail () {
        for (var i in this.merchandises._attributes) {
          if (this.merchandises._attributes[i].groupId === 2 || this.merchandises._attributes[i].groupId === 3) {
            this.merchandises._attributes[i].sorteditAble = true
          }
        }
        this.$router.replace({name: 'finderMerchandises', params: {merchandises: this.merchandises}})
      },
      calculatePrice () {
        for (var a in this.curAttrsInGroup) {
          if (this.curAttrsInGroup[a].columnName !== 'TvNoName' && this.curAttrsInGroup[a].columnName !== 'TvNoNumber') {
            if (this.curAttrsInGroup[a].isNA === false && this.curAttrsInGroup[a].value === '') {
              this.$weui.alert('请将信息填写完整！')
              return
            }
          }
        }
        Emkt.setLocalStorage('TLNo', null)
        let bMerchandise = this.merchandiseHandler()
        let _this = this
        // $.showIndicator()
        this.$weui.loading('查询商品中')
        this.gcapi('productDetect', bMerchandise).then(res => {
          let body = res.body
          if (body.code === 0) {
            let merchandise = {}
            merchandise = body.result.merchandiseDetailForClient
            merchandise.productName = body.result.productName
            merchandise.workdays = body.result.workdays
            merchandise.expressPrice = body.result.expressPrice
            merchandise.amplification = body.result.amplification
            if (merchandise.amplification === 1) {
              merchandise.priceMin = body.result.priceMax
            } else {
              merchandise.priceMin = body.result.priceMin
            }
            merchandise.priceMax = body.result.priceMax
            if (body.result.templateSource) {
              merchandise.templateSource = body.result.templateSource
            }
            if (_this.$route.query.cust && _this.$route.query.cust.id) {
              merchandise.id = _this.$route.query.cust.id
            }
//            _this.merchandises.priceMin = body.result.price
            _this.addCartList(merchandise)
//            this.attrHandler()
            // if (merchandise.amplification === 1) {
            //   window.location.reload()
            // }
          } else {
            _this.$weui.topTips(body.result, 1000)
            // $.toast(body.result)
          }
        })
      },
      merchandiseHandler () {
        let md = this.merchandises
        let bMerchandise = {}
        let attribute = []
        // md._customizableAttributes['GeneInfo'] = md._attributesList[md._attributesList.length - 1]
        let attr = md._attributes
        let categoryId
        for (var akey in attr) {
          if (akey === 'GeneInfo') {
            attribute.push({key: akey, value: attr[akey].value.geneGUID})
            categoryId = attr[akey].value.category
            this.geneObject = attr[akey].value
            this.geneObject = attr[akey].value
            if (this.geneObject !== null) {
              var taxId = {}
              taxId.columnName = 'GeneInfo.taxId'
              taxId.value = this.geneObject.taxId
              taxId.valueText = this.geneObject.taxId
              var symbol = {}
              symbol.columnName = 'GeneInfo.symbol'
              symbol.value = this.geneObject.symbol
              symbol.valueText = this.geneObject.symbol
              this.merchandises._abstractList.push(taxId)
              this.merchandises._abstractList.push(symbol)
            }
          } else if (akey === 'AAVBloodType]') {
            attribute.push({key: akey, value: attr[akey].value.geneGUID})
            categoryId = attr[akey].value.category
            this.geneObject = attr[akey].value
          } else {
            let obj = {}
            obj['key'] = akey
            let val = attr[akey].value
            if (val === '') {
              obj['value'] = -1
            } else if (val) {
              if (val.value !== undefined) {
                obj['value'] = val.value
              } else {
                obj['value'] = val
              }
            } else if (val === 0) {
              obj['value'] = val
            }
            if (obj['key'] === 'TVInfo') {
              if (obj['value'].TLNo === undefined) {
                obj['value'] = obj['value']
              } else {
                obj['value'] = obj['value'].TLNo
              }
            }
//            if (obj['key'] === 'InducingTest' || obj['key'] === 'ExpressionTest' === 0) {
//              obj['value'] = 0
//            }
//            if (obj['key'] === 'ProductGuid') {
//              bMerchandise.productGuid = obj['value']
//            }
            attribute.push(obj)
          }
        }
        let cate = {}
        cate['key'] = 'GeneInfo.category'
        cate['value'] = categoryId
        attribute.push(cate)
        bMerchandise.unitPrice = md.priceMax
        bMerchandise.initPrice = bMerchandise.unitPrice
        bMerchandise.merchandiseGuid = md.merchandiseId
        bMerchandise.amplification = md.amplification
        bMerchandise.attributes = attribute
        bMerchandise.MerchantNo = '101'
        bMerchandise.newMerch = 1
//        bMerchandise.productGuid = attribute['ProductGuid'].value
//        bMerchandise.geneObject = geneObject
        return bMerchandise
      },
      gotolast () {
        if (this.$route.params.order) {
          this.$router.replace({name: 'orderContent', params: {order: this.$route.params.order}})
        } else if (this.$route.query.id) {
          this.$router.replace({name: 'cart'})
        } else if (this.$route.params.type) {
          this.$router.go(-1)
        } else {
          for (var i in this.merchandises._attributes) {
            if (this.merchandises._attributes[i].groupId === 2 || this.merchandises._attributes[i].groupId === 3) {
              this.merchandises._attributes[i].sorteditAble = true
            }
          }
          this.$router.replace({name: 'finderMerchandises', params: {merchandises: this.merchandises}})
        }
//        this.$router.go(-1)
      },
      controlForm (index) {
      },
      getEditor (attribute) {
//        if (attribute.customizable === 1) {
//          if (attribute.columnName === 'PreContract') {
//            return 'attr-contract-box'
//          } else if (attribute.columnName === 'CloneNrSelect') {
//            return 'attr-target-box'
//          } else if (attribute.columnName === 'TemsPreContract') {
//            return 'attr-temcontract-box'
//          } else {
//            if (attribute.sdType === Emkt.SDTGene) {
//              return 'attr-gene-box'
//            } else if (attribute.sdType === Emkt.SDTToolVector) {
//              return 'attr-tv-box'
//            } else if (attribute.sdType === Emkt.SDTEnumeration) {
//              return 'finder-attr-enum-box'
//            } else if (attribute.sdType === Emkt.SDTInteger) {
//              return 'finder-attr-number-box'
//            } else if (attribute.sdType === Emkt.SDTDecimal) {
//              return 'finder-attr-number-box'
//            } else {
//              return 'finder-attr-text-area-box'
//            }
//          }
//        }
        if (attribute.sdType === Emkt.SDTGene) {
          return 'finder-attr-gene-box'
        } else if (attribute.sdType === Emkt.SDTEnumeration) {
          return 'finder-attr-enum-box'
        } else if (attribute.sdType === Emkt.SDTInteger) {
          return 'finder-attr-number-box'
        } else if (attribute.sdType === Emkt.SDTToolVector) {
          return 'finder-attr-tv-box'
        } else if (attribute.sdType === Emkt.SDTDecimal) {
          return 'finder-attr-number-box'
        } else {
          return 'finder-attr-text-box'
        }
      },
      getSecPromotionDetail () {
        if (!this.merchandises.promotions) return
        for (let promotion of this.merchandises.promotions) {
          if (promotion.type !== 6) continue
          this.secPromotionDetail = this.secPromotionDetailObj[promotion.promotionGuid]
          this.numRequiredForSecPromotion = this.secPromotionDetail && this.secPromotionDetail.requiredQuantity
          break
        }
      },
      fetchData () {
        console.log(this.$route.query.id)
        if (this.$route.query.merchandises) {
          if (this.isWapp) {
            this.gcapi('getWappMerchandiseDetail', this.$route.query.merchandises)
                  .then((response) => {
                    const result = response.body.result
                    this.merchandises = JSON.parse(result)
                    for (var j in this.merchandises._attributesList) {
                      this.merchandises._attributesList[j].sorteditAble = false
                    }
                  })
          } else {
            this.merchandises = JSON.parse(this.$route.query.merchandises)
            for (var j in this.merchandises._attributesList) {
              this.merchandises._attributesList[j].sorteditAble = false
            }
          }
        } else {
          this.merchandises = this.$route.params.merchandises
        }

//        this.merchandises._attributes.forEach(item => {
//          item.sorteditAble = false
//        })
        console.log('finderOrderDeail merchandises', this.merchandises)
        this.getSecPromotionDetail()
        for (var i in this.merchandises._attributes) {
          this.merchandises._attributes[i].sorteditAble = false
        }
        this.gcapi('getMerchandiseComments', this.$route.query.id).then((response) => {
          this.Comments = response.body.result
        })
      },
      addcss (data) {
        var obj1 = document.getElementById('detail')
        var obj2 = document.getElementById('introduce')
        var obj3 = document.getElementById('qualityCommitment')
        var obj4 = document.getElementById('comments')
        if (data === 1) {
          obj1.style.cssText = ' border-bottom: 1px solid ;color: #0894ec;'
          obj2.style.cssText = 'border: 0px solid black;'
          obj3.style.cssText = 'border: 0px solid black;'
          obj4.style.cssText = 'border: 0px solid black;'
        } else if (data === 2) {
          obj2.style.cssText = ' border-bottom: 1px solid; color: #0894ec;'
          obj1.style.cssText = 'border: 0px solid black;'
          obj3.style.cssText = 'border: 0px solid black;'
          obj4.style.cssText = 'border: 0px solid black;'
        } else if (data === 3) {
          obj3.style.cssText = ' border-bottom: 1px solid;color: #0894ec;'
          obj1.style.cssText = 'border: 0px solid black;'
          obj2.style.cssText = 'border: 0px solid black;'
          obj4.style.cssText = 'border: 0px solid black;'
        } else if (data === 4) {
          obj4.style.cssText = ' border-bottom: 1px solid;color: #0894ec;'
          obj1.style.cssText = 'border: 0px solid black;'
          obj3.style.cssText = 'border: 0px solid black;'
          obj2.style.cssText = 'border: 0px solid black;'
        }
      },
      toMessage () {
        Emkt.openCustomerService()
        // window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
//        this.$router.push({name: 'myMessage', query: {merchandiseurl: this.$route.fullPath}})
      },
      showSecPromotionInfo () {
        console.log('detail session', this.sessionInfo.customerInfo)
        if (this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.ssoFlag === 1) {
          return false
        }
        console.log('detail merchandises.promotions', this.merchandises.promotions)
        if (this.merchandises.promotions) {
          return this.merchandises.promotions[0] && this.merchandises.promotions[0].type === 6 && this.secFlag !== 2
        } else {
          return this.merchandises.bpromotions && this.merchandises.bpromotions[0] && this.merchandises.bpromotions[0].type === 6 && this.secFlag !== 2
        }
      },
      gotoCart () {
        if (Emkt.isWapp) {
          wx.miniProgram.switchTab({
            url: '/pages/cart/cart'
          })
        } else {
          this.$router.replace({name: 'cart'})
        }
      }
    }

  }
</script>
<style scoped>


.specal {
  border-bottom: 0px solid;
}
  .checkbox-el {
    display: inline-block;
    text-align: left;
  }
.options {
  color: grey;
  font-size: .6rem;
  width: 120px;
  margin-left: .3rem;
}

  .item-title {
    font-size: 0.6rem;
    color: black;
  }
  .guding {
    width: 140px;
  }
  .item-after {
    font-size: 0.6rem;
    color: black;
  }
.gotopay{
  position: absolute;
  right: 0;
  background-color: #00469A;
@include wh(5rem, 100%);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -2.5rem;
  width: 5rem;
  height: 3rem;}
.gotopay_button_style{
@include sc(.7rem, #F6383A);
  font-weight: bold;
  color: #fff;

}
.page {
  background-color: white;
}
.bar-header-secondary~.content{top:3.9rem;}
.bar-footer~.content{bottom:1.0rem}

.searchbox {
  font-weight: 350;
  padding-left: 1.5rem;
}
.goback {
  color: gray;
}
.button.active {
  z-index: 100;
  color: #00469A;
  background-color: white;
  border-bottom: 1px solid
}
.bar-tab .tab-item{
  width: 0%
}
.tab-link.button {
  border: 0px solid black;
  color: gray;
  border-radius: 0;
}
.bar_1 {
    position: absolute;
    right: 0;
    left: 0;
    z-index: 10;
    height: 3.6rem;
    padding-right: .5rem;
    padding-left: .5rem;
    border-bottom: 1px solid #e7e7e7;
    backface-visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// finderOrderDeail.vue?374abb2a